import React from 'react';

const Error = () => (<h1>ERROR!!!</h1>);

export default Error;
